export default __webpack_public_path__ + "static/featured-articles-section_hero-mobile-f6993ad1e6a74a5adb54872fc913a77a.jpg";